import React, { createContext, useContext, useState, useEffect } from 'react';

export type Theme = 'green' | 'blue' | 'orange' | 'purple' | 'brown' | 'teal' | 'rose' | 'graphite' | 'midnight' | 'peach' | 'periwinkle' | 'beige' | 'pastel' | 'cyan-pink';

interface ThemeContextProps {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextProps>({
  theme: 'teal',
  setTheme: () => { },
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setThemeState] = useState<Theme>('teal');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
